import { ValidationProps, ValidationLevel } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ValueProperty } from 'app/types-shared';

export const validateComplexValue = (
  key: keyof CodeItem,
  codeItem: CodeItem,
  translation: CodetableTranslation
): { [key in keyof CodeItem]?: ValidationProps } => {

  const property = codeItem[key] as CodeComplexValue<ValueProperty>;

  return {
    [key]: !!property && isDefinedIncludingZero(property.value) ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};

export const validateIfFilledOut = (
  key: keyof CodeItem,
  condition: boolean,
  translation: CodetableTranslation
): { [key in keyof CodeItem]?: ValidationProps } => {

  return {
    [key]: condition ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};

export const validateIfNotEqual = (
  firstKey: keyof CodeItem,
  secondKey: keyof CodeItem,
  codeItem: CodeItem,
  message: string
): { [key in keyof CodeItem]?: ValidationProps } => {

  const firstProperty = codeItem[firstKey] as CodeComplexValue<ValueProperty>;
  const secondProperty = codeItem[secondKey] as CodeComplexValue<ValueProperty>;

  const arePropertiesEqual = !!firstProperty && !!secondProperty && firstProperty.value === secondProperty.value;

  return arePropertiesEqual
    ? {
      [firstKey]: {
        level: ValidationLevel.error,
        messages: [{
          level: ValidationLevel.error,
          message
        }]
      },
      [secondKey]: {
        level: ValidationLevel.error,
        messages: [{
          level: ValidationLevel.error
        }]
      }
    } : undefined;
};
